<template>
    <div class="test-details-item">
        <div class="test-details-icon -center">
            <icon-like-reaction/>
        </div>
        <div class="test-details-content">
            <div class="test-reaction">
        <div class="test-reaction-text">
            Чи була надана інформація корисна?
        </div>
        <div class="test-reaction-content">
            <div class="test-reaction-stat">
                <div class="test-reaction-stat-line">
                    <div class="test-reaction-stat-progress" :style="{width: reactionPercent + '%'}"></div>
                </div>
                <div>
                    <span>{{ reactionPercent }}%</span>
                    (<span class="test-reaction-stat-like">{{ likes }}/</span>
                    <span class="test-reaction-stat-dislike">{{ dislikes }}</span>)
                </div>
            </div>
            <div class="test-reaction-controls">
                <button @click="setVote(1)" class="test-reaction-control"
                        :class="{'like-active': getIfUserReacted(1)}">
                    <icon-smile-like/>Так
                </button>
                <button @click="setVote(0)" class="test-reaction-control"
                        :class="{'dislike-active': getIfUserReacted(0)}">
                    <icon-smile-dis-like/>Ні
                </button>
                <div class="test-reaction-control" @click="$emit('showshare')">
                    <icon-share/>
                </div>
            </div>
        </div>
    </div>
        </div>
    </div>
</template>
<script>
import IconSmileLike from '../../icons/IconSmileLike';
import IconSmileDisLike from '../../icons/IconSmileDisLike';
import IconShare from '../../icons/IconShare';
import IconLikeReaction from '../../icons/IconLikeReaction.vue';
import {userIdentifyHelper} from "../../../helpers/UserIdentifyHelper";

export default {
    name: "TestReaction",
    components: {IconLikeReaction, IconShare, IconSmileDisLike, IconSmileLike},
    props: ['testId', 'likes', 'dislikes', 'userData'],
    data() {
        return {
            userReactions: JSON.parse(localStorage.getItem('user_reactions')) || []
        }
    },
    computed: {
        reactionPercent() {
            if (this.likes === 0 && this.dislikes === 0) {
                return 0
            }
            return Math.floor((+this.likes / (+this.likes + +this.dislikes)) * 100)
        },
    },
    methods: {
        getIfUserReacted(reaction) {
            if (this.getaReactionsArrayIndex() !== -1) {
                return this.userReactions[this.getaReactionsArrayIndex()].vote === reaction
            } else {
                return false
            }
        },
        getaReactionsArrayIndex() {
            return this.userReactions.findIndex(item => item.test === this.testId)
        },
        setVote(reaction) {
            if(this.userData) {
                this.vote(reaction, this.userData.requestId, this.userData.visitorId);
            } else {
                this.getVisitorData().then(data => {
                    this.vote(reaction, data.requestId, data.visitorId);
                })
            }
        },
        vote(reaction, request, visitor) {
            fetch(`${window.location.origin}/api/v1/tests/${this.testId}/vote`, {
                method: 'POST',

                headers: {
                    'Content-Type' : 'application/json'
                },
                body: JSON.stringify({
                    "vote": parseInt(reaction),
                    "request_id": request,
                    "visitor_id": visitor
                }),
            }).then((response) => {
                return response.json();
            }).then((data) => {
                if (this.getaReactionsArrayIndex() !== -1) {
                    this.userReactions[this.getaReactionsArrayIndex()].vote = reaction
                } else {
                    this.userReactions.push({
                        test: this.testId,
                        vote: reaction
                    })
                }

                localStorage.setItem('user_reactions', JSON.stringify(this.userReactions))
                const testDataReactions = {
                    testId: this.testId,
                    testLikes: data.vote_good,
                    testDislikes: data.vote_bad
                }
                this.$parent.$emit('updatelikes', testDataReactions)
            }).catch((error) => {
                console.error('Error:', error);
            });
        },
        async getVisitorData() {
            return await userIdentifyHelper.get();
        }
    }
}
</script>
<style lang="scss" scoped>
@import "../../../../../sass/front/helpers";

.test-reaction {
    padding: 2rem;
    border: 1px solid #E9EBEF;
    border-radius: 1rem;
    display: flex;
    gap: 12px;
    justify-content: space-between;
    align-items: center;

    @include responsive-below($md) {
        flex-direction: column;
        align-items: flex-start;
    }

    &-text {
        font-size: 14px;
    }

    &-stat {
        display: flex;
        align-items: center;
        color: #959595;
        gap: 12px;
        font-size: 10px;
        margin-bottom: 6px;

        &-line {
            background: #F3F3F4;
            border-radius: 10px;
            width: 80px;
            height: 6px;
            position: relative;
        }

        &-progress {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            background-color: #5ECA9A;
            border-radius: 10px;
        }

        &-like {
            color: #3CC13B;
        }

        &-dislike {
            color: #B70000;
        }
    }
    &-controls {
        display: flex;
        gap: 4px;
    }

    &-control {
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        padding: 3px 12px;
        min-height: 26px;
        min-width: 60px;
        background-color: #F3F3F4;
        border-radius: 7px;
        font-size: 11px;
        border: 0;
        transition: background-color 0.3s;

        &:hover {
            background-color: #E8E8E8;
        }

        &.like-active {
            background-color: #ECFFEC;
        }

        &.dislike-active {
            background-color: rgba(183, 0, 0, 0.1);
        }
    }
}

.test-details-icon.-center {
    top: calc(50% - 2.6rem);

    &:before {
        content: "";
        display: block;
        width: 1rem;
        height: 0.2rem;
        background: #E9EBEF;
        border-radius: 8px;
        position: absolute;
        left: calc(100% + 0.1rem);
        top: 50%;
    }
}

</style>
